module.exports = __webpack_public_path__ + "img/faceberry_midup.9a0664ce.png";